import { useEffect, useState } from 'react';

const getIsPageVisible = () => typeof window !== 'undefined' && document.visibilityState === 'visible';

const useIsPageVisible = () => {
  const [isVisible, setIsVisible] = useState(getIsPageVisible);

  useEffect(() => {
    const handleVisibilityChange = () => setIsVisible(getIsPageVisible());
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  return isVisible;
};

export default useIsPageVisible;
